import apiClient from 'api/apiClient';
import API_END_POINT from 'constants/apiEndPoints';
import { ApiResponse, ProjectInfoFormValues } from 'types';

interface CreateProjectParams extends ProjectInfoFormValues {}

interface CreateProjectApiResponse extends ApiResponse {
  ownerName: string;
  ownerEmail: string;
  projectId: string;
  projectName: string;
}

type CreateProject = (params: CreateProjectParams) => Promise<CreateProjectApiResponse>;

const createProject: CreateProject = async ({ projectName, framework, frameworkVersion, direction }) => {
  const { data } = await apiClient.post(API_END_POINT.PROJECT.CREATE_PROJECT, {
    projectInfo: {
      projectName,
      projectDesc: '',
      projectScope: 'Public',
      framework,
      frameworkVersion,
      direction,
    },
    hyperparameter: {
      dataPath: './data',
      maxEpochs: 0,
      batchSize: 0,
      earlyStop: 0,
      shuffle: false,
      useVal: false,
      makeVal: false,
      dataRatio: 1,
    },
  });

  return data;
};

export default createProject;
